import React from 'react';
import { create, InstanceProps } from 'react-modal-promise';

import { IconButton } from 'components';
import Modal from 'components/Modal';

import { ConfirmationButtonResponse } from 'hooks/UseCompanyCampaigns';
import { ButtonV3 } from '..';
import styles from './ConfirmationModal.module.scss';

const ModalInstance: React.FC<InstanceProps<number>> = ({
  isOpen,
  onResolve,
  onReject,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onReject}
    contentClassName={styles.container}
    className={styles.modal}
  >
    <div className={styles.content}>
      <IconButton
        size="xsmall"
        iconName="close"
        className={styles.cancelIcon}
        onClick={() => onReject()}
      />
      <p className={styles.emoji}>❓</p>
      <p className={styles.title}>Save changes</p>
      <p className={styles.desc}>
        Your changes are not saved. Do you want to save changes before closing?
      </p>
      <ButtonV3
        isFullWidth={true}
        borderRadius={20}
        onClick={() => onResolve(ConfirmationButtonResponse.SAVE)}
      >
        Save
      </ButtonV3>
      <ButtonV3
        isFullWidth={true}
        borderRadius={20}
        variant="text"
        color="black"
        onClick={() => onResolve(ConfirmationButtonResponse.DONT_SAVE)}
      >
        Don’t save
      </ButtonV3>
    </div>
  </Modal>
);

export const confirmationModalInstance = create(ModalInstance);
